import { Button } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import OrderList from "../components/Orders/OrderList";
import { Order } from "../entities/interfaces/order";
import OrderService from "../services/orders.service";
import { Page, PageParams } from "../entities/interfaces/misc";
import { usePage } from "../hooks/usePage";
import PaginationWrapper from "../components/misc/PaginationWrapper";
// import ManageService from "../components/orders/ManageClient";
// import ServiceList from "../components/orders/ServiceList";
// import { Order } from "../entities/interfaces/order";
// import ServiceService from "../orders/orders.order";

const Orders = () => {
  const [orders, setServices] = useState<Page<Order[]>>({
    data: [],
    pageOptions: undefined,
  });
  const [manageServiceModal, setManageServiceModal] = useState(false);
  const [selected, setSelected] = useState<Order | undefined>();

  const navigate = useNavigate();

  useEffect(() => {
    // getServices();
  }, []);

  const getServices = async (pageParams: PageParams) => {
    const res = await OrderService.list(pageParams);
    if (!res?.success) return;
    setServices({
      data: res.data,
      pageOptions: res.meta,
    });
  };

  const openManageServiceModal = () => {
    setManageServiceModal(true);
  };

  const closeManageServiceModal = () => {
    if (selected) {
      setSelected(undefined);
    }
    setManageServiceModal(false);
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-5">
          <h1 className="text-xl font-bold">Orders</h1>
          <p>Manage your organisation orders</p>
        </div>
        <Button type="primary" onClick={() => navigate("/orders/create")}>
          Create Order
        </Button>
        {/* 
        <ManageService
          open={manageServiceModal}
          onChange={getServices}
          onClose={closeManageServiceModal}
          selected={selected}
        /> */}
      </div>
      <PaginationWrapper
        fetcher={getServices}
        totalPage={orders.pageOptions?.total}
      >
        <OrderList
          orders={orders.data}
          onSelect={(data) => {
            openManageServiceModal();
            setSelected(data);
          }}
        />
      </PaginationWrapper>
    </div>
  );
};

export default Orders;
